<template>
    <div class="warp">
        <div class="echarts" ref="echarts"></div>
    </div>
</template>
<script>
import echarts from 'echarts'
export default {
    name: 'echartsLine',
    props: ['instructionEchartsData'],
    data() {
        return {
            visitclientnumYdata: [5, 7, 8, 10, 15, 19, 17, 18, 14, 12, 6, 5],
            commentNumYdata: [3, 5, 6, 9, 12, 16, 15, 11, 8, 5, 3, 1],
            commentUsersNumYdata: [2, 4, 5, 8, 11, 15, 14, 10, 7, 4, 4, 2],
            xdisplaydata: ['2019-04-01', '2019-04-02', '2019-04-03', '2019-04-04', '2019-04-05', '2019-04-06', '2019-04-07', '2019-04-08', '2019-04-09', '2019-04-10', '2019-04-11', '2019-04-12']
        }
    },
    watch: {
        instructionEchartsData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.initChart(this.instructionEchartsData)
            })
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    mounted() {},
    methods: {
        initChart(Edata) {
            this.xdisplaydata = Edata[0].xdisplaydata
            this.visitclientnumYdata = Edata[2].visitclientnumYdata
            this.commentNumYdata = Edata[1].commentNumYdata
            this.commentUsersNumYdata = Edata[3].commentUsersNumYdata
            this.chart = echarts.init(this.$refs.echarts)
            this.chart.setOption(this.getOption())
        },
        getOption: function() {
            return {
                color: ['#41CCF0', '#67C23A', '#F5CC4D'],
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['浏览用户数', '评论数', '评论用户数'],
                    icon: 'circle',
                    itemWidth: 10, // 设置宽度
                    itemHeight: 10 // 设置高度
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    data: this.xdisplaydata
                },
                yAxis: {
                    type: 'value',
                    name: '',
                    // nameTextStyle: {
                    //     color: 'red'
                    // },
                    axisLabel: {
                        color: '#545454' // 刻度线标签颜色
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#f2f2f2'],
                            type: 'dashed'
                        }
                    }
                },
                series: [
                    {
                        name: '浏览用户数',
                        type: 'line',
                        data: this.visitclientnumYdata
                    },
                    {
                        name: '评论数',
                        type: 'line',
                        data: this.commentNumYdata
                    },
                    {
                        name: '评论用户数',
                        type: 'line',
                        data: this.commentUsersNumYdata
                    }
                ]
            }
        }
    }
}
</script>
<style scoped>
.warp {
    width: 100%;
    height: 100%;
}
.echarts {
    width: 100%;
    height: 100%;
}
</style>